/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown> }} Input_Slider_Aria_LabelInputs */

const en_input_slider_aria_label = /** @type {(inputs: Input_Slider_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} slider`)
};

const fr_input_slider_aria_label = /** @type {(inputs: Input_Slider_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Curseur ${i?.label}`)
};

const de_input_slider_aria_label = /** @type {(inputs: Input_Slider_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} Schieberegler`)
};

const it_input_slider_aria_label = /** @type {(inputs: Input_Slider_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`cursore ${i?.label}`)
};

const ru_input_slider_aria_label = /** @type {(inputs: Input_Slider_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} ползунок`)
};

const es_input_slider_aria_label = /** @type {(inputs: Input_Slider_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Control deslizante ${i?.label}`)
};

const zh_cn2_input_slider_aria_label = /** @type {(inputs: Input_Slider_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label}滑块`)
};

const ja_input_slider_aria_label = /** @type {(inputs: Input_Slider_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} スライダー`)
};

const hi_input_slider_aria_label = /** @type {(inputs: Input_Slider_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} स्लाइडर`)
};

const pt_pt2_input_slider_aria_label = /** @type {(inputs: Input_Slider_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} controle deslizante`)
};

/**
* | output |
* | --- |
* | "{label} slider" |
*
* @param {Input_Slider_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_slider_aria_label = /** @type {((inputs: Input_Slider_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Slider_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_input_slider_aria_label(inputs)
	if (locale === "de") return de_input_slider_aria_label(inputs)
	if (locale === "it") return it_input_slider_aria_label(inputs)
	if (locale === "ru") return ru_input_slider_aria_label(inputs)
	if (locale === "es") return es_input_slider_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_input_slider_aria_label(inputs)
	if (locale === "ja") return ja_input_slider_aria_label(inputs)
	if (locale === "hi") return hi_input_slider_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_input_slider_aria_label(inputs)
	return en_input_slider_aria_label(inputs)
});